import { Text } from "@primer/react";
import { ChevronRightIcon, PackageIcon, ShieldCheckIcon, TagIcon } from "@primer/octicons-react";
import "../IdentityLink/IdentityLink.css";
import "./PolicyIdentity.css";

const identityIcons = { asset: PackageIcon, policy: ShieldCheckIcon, property: TagIcon };

export function policyHref(policyId) {
  return `#/policies/${encodeURIComponent(policyId)}`;
}

export function PolicyIdentity({ document, href, identityType = "policy", policy, size = "normal", variant = "structured" }) {
  const IdentityIcon = identityIcons[identityType];
  if (variant === "subject") return <PolicySubjectIdentity document={document} href={href} IdentityIcon={IdentityIcon} identityType={identityType} policy={policy} size={size} />;
  const segments = policySegments(document, policy);
  const Target = href ? "a" : "span";
  return <Target className={`${size} ${identityType} policy-identity identity-link`} href={href}><IdentityIcon className="policy-icon" aria-hidden="true" />{segments.map((segment, index) => <span className="policy-segment" key={segment}>{index ? <ChevronRightIcon className="policy-separator" size="small" aria-hidden="true" /> : null}{index === 0 ? <strong className="identity-link-label">{segment}</strong> : <Text>{segment}</Text>}</span>)}</Target>;
}

function PolicySubjectIdentity({ document, href, IdentityIcon, identityType, policy, size }) {
  const title = policyDisplayTitle(document, policy);
  const Target = href ? "a" : "span";
  return <Target aria-label={title.label} className={`${size} ${identityType} subject policy-identity identity-link`} href={href}><IdentityIcon className="policy-icon" aria-hidden="true" /><span className="identity-link-label policy-label"><strong className="identity-link-part policy-primary">{title.primary}</strong>{title.context ? <>{" "}<Text as="span" className={`identity-link-part policy-context ${title.contextTone}`}>{title.context}</Text></> : null}</span></Target>;
}

export function policyDisplayTitle(document, policy) {
  if (policy.scope.type === "specific") {
    const property = document.properties.find((item) => item.id === policy.scope.propertyId);
    const value = property.values.find((item) => item.id === policy.scope.valueId);
    return { label: `${value.name} ${property.name}`, primary: value.name, context: property.name, contextTone: "muted" };
  }
  if (policy.scope.dimension.type === "asset") return { label: "Any Asset", primary: "Any", context: "Asset", contextTone: "default" };
  const property = document.properties.find((item) => item.id === policy.scope.dimension.propertyId);
  return { label: `Any ${property.name}`, primary: "Any", context: property.name, contextTone: "default" };
}

export function policyTitle(document, policy) {
  if (policy.scope.type === "specific") {
    const property = document.properties.find((item) => item.id === policy.scope.propertyId);
    const value = property.values.find((item) => item.id === policy.scope.valueId);
    return `${property.name} ${value.name}`;
  }
  const dimension = policy.scope.dimension;
  return dimension.type === "asset" ? "Asset" : document.properties.find((item) => item.id === dimension.propertyId).name;
}

function policySegments(document, policy) {
  if (policy.scope.type === "specific") {
    const property = document.properties.find((item) => item.id === policy.scope.propertyId);
    const value = property.values.find((item) => item.id === policy.scope.valueId);
    return ["Exposure", property.name, value.name];
  }
  const dimension = policy.scope.dimension;
  const label = dimension.type === "asset" ? "Asset" : document.properties.find((item) => item.id === dimension.propertyId).name;
  return ["Concentration", label];
}
